import React, { useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const ObjectiveCard = ({ card }) => {
  return (
    <div className="bg-swiss-150 rounded-xl p-4 md:p-6 flex flex-col items-center text-center">
      <div
        className="w-16 h-16 md:w-16 md:h-16 mb-3 flex items-center justify-center [&>svg]:w-full [&>svg]:h-full"
        dangerouslySetInnerHTML={{ __html: card.icon }}
      />
      <p
        className="text-sm md:text-base text-white font-medium leading-relaxed"
        dangerouslySetInnerHTML={{ __html: card.text }}
      />
    </div>
  );
};

const MobileCarousel = ({ cards }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) goToNext();
    if (isRightSwipe) goToPrev();
  };

  return (
    <div className="relative px-2">
      <div className="relative flex items-center">
        {cards.length > 1 && (
          <button
            onClick={goToPrev}
            className="absolute -left-1 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-gray-200 shadow flex items-center justify-center z-10">
            <IoIosArrowBack className="text-gray-500" size={16} />
          </button>
        )}

        <div
          className="w-full px-8 overflow-hidden"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}>
          <div
            className="flex transition-transform duration-300 ease-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {cards.map((card, index) => (
              <div key={index} className="w-full flex-shrink-0 px-1">
                <ObjectiveCard card={card} />
              </div>
            ))}
          </div>
        </div>

        {cards.length > 1 && (
          <button
            onClick={goToNext}
            className="absolute -right-1 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-gray-200 shadow flex items-center justify-center z-10">
            <IoIosArrowForward className="text-gray-500" size={16} />
          </button>
        )}
      </div>

      {cards.length > 1 && (
        <div className="flex justify-center gap-2 mt-5">
          {cards.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-200 ${
                index === currentIndex ? 'bg-[#1C5191] scale-110' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

function ObjectivesMF2026({ translations }) {
  return (
    <section className="bg-swiss-100 py-10 md:py-14">
      <div className="container mx-auto max-w-5xl px-4 md:px-6">
        <div className="text-center mb-8">
          <h2
            className="text-2xl md:text-3xl font-bold text-[#333333] mb-2"
            dangerouslySetInnerHTML={{ __html: translations?.title }}
          />
          <p
            className="text-lg md:text-xl font-semibold text-[#333333]"
            dangerouslySetInnerHTML={{ __html: translations?.subtitle }}
          />
        </div>

        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.isArray(translations?.cards) &&
            translations.cards.map((card, index) => <ObjectiveCard key={index} card={card} />)}
        </div>

        <div className="block md:hidden">
          {Array.isArray(translations?.cards) && <MobileCarousel cards={translations.cards} />}
        </div>
      </div>
    </section>
  );
}

export { ObjectivesMF2026 };
